// extracted by mini-css-extract-plugin
export var addressFields = "_o0-0";
export var animationContainer = "_o0-1";
export var footer = "_o0-2";
export var lineItems = "_o0-3";
export var modalContent = "_o0-4";
export var orderName = "_o0-5";
export var strong = "_o0-6";
export var warning = "_o0-7";